
import React from 'react';
import { DatePicker } from "@/components/ui/date-picker";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface DatePickerFieldProps {
  label: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
}

export function DatePickerField({ 
  label, 
  value, 
  onChange, 
  placeholder = "Select date" 
}: DatePickerFieldProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium">{label}</label>
        {value && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => onChange(null)}
            className="h-6 w-6 p-0 text-muted-foreground hover:text-foreground"
          >
            <X className="h-3 w-3" />
          </Button>
        )}
      </div>
      <DatePicker
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={(date) => date < new Date("1900-01-01")}
      />
    </div>
  );
}
